<template>
	<!-- 宿舍管理-->
	<div class="fuzzy-matching-box">
		<div class="fuzzy-matching-top">
            <el-button type="primary" class="query-button" @click="AddPeople">新增</el-button>
           
			<el-button class="query-button1" @click="DtlConfirmBtn()">删除</el-button>
		</div>

		<div class="Table-Bottom">
			<el-table v-loading="loading" stripe :border="true"
				:header-cell-style="{ background: '#EDF6FF', color: '#000', height: '40px' }" ref="multipleTable"
				:data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column type="index" label="序号" width="100">
				</el-table-column>
				<el-table-column  label="头像" show-overflow-tooltip>
                    <template #default="scope">
						<span v-if="scope.row.logo !='' && scope.row.logo != null">
							<img   :src="scope.row.logo" :alt="imgs" style="height: 30px; width: 30px;">
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="管理员名称" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="mobile" label="注册号码" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="buildingCount" label="管理楼栋" show-overflow-tooltip>
				</el-table-column>
                <el-table-column  label="状态" show-overflow-tooltip>
                    <template #default="scope">
                    <span v-if="scope.row.status == 1" >正常</span>
                    <span v-if="scope.row.status == 0" >禁用</span>
                    <span v-if="scope.row.status == 99" >黑名单</span>
                </template>
				</el-table-column>
                <el-table-column prop="created" label="添加时间" show-overflow-tooltip>
				</el-table-column>
				
				<el-table-column label="操作" min-width="100">
					<template #default="scope">
						<el-button class="textButton" type="text" size="small"
							@click="alterAdd(scope.row)">修改</el-button>
						<!-- <el-button class="textButton" type="text" size="small" @click="statusClick(scope.row)" v-if="scope.row.status == 1">加入黑名单</el-button> -->
						<el-button class="shanchuBtn" type="text" @click="DtlConfirmBtn(scope.row)">删除</el-button>

					</template>
				</el-table-column>
			</el-table>
			<!-- <div style="margin-top: 20px">
				<el-button @click="deleteClick">批量删除</el-button>
			</div> -->

			<div class="block-fenye">
				<el-pagination :small="small" :disabled="disabled" :background="background"
					layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" />
			</div>
		</div>
        <Add v-if="AddShow" :detailsObj='detailsObj' @AddShowClick="AddShowClick"></Add>

	</div>
</template>

<script>
import {
    SuSheListMember,
	memberDelete,
	memberUpdateStatus
} from '@/assets/api/logapi.js'
import {
	findTeacherInfo,
} from '@/assets/api/renyuan';
import Add from './child/add.vue';
export default {
	components: {
		Add
	},
	data() {
		return {
			AddShow: false,
			Dform: {
				name: ''
			},
            loading:true,
			pageInfo: {
				page: 1,
				pageSize: 10,
			},
			LouData: [],
			schoolInfo: {},
			tableData: [],
			total: 0,
			schoolListTopId: '',
			deleteList: [],
			detailsObj:{}
		}
	},
	created() {
		this.Lookteacher()
	
		// this.menuGetUserTreeGet()
	},
	methods: {
		//启用/禁用
		enableBtn(res){	
			if (this.deleteList.length) {
				memberUpdateStatus(this.deleteList[0].id,res).then((res) => {
					console.log(res,'99999999');
					
				})
			}else{
				this.$message({
					type: 'error',
					message: '请选择要修改状态的数据'
				});
			}

		},
		//修改
		alterAdd(row){
			this.detailsObj = row
			this.AddShow = true
		},
		//新增
		AddPeople(){
			if (this.schoolInfo.schoolId) {
				this.AddShow = true
			}else{
				this.$message({
						message: '该账号没有权限，请登录学校账号！',
						type: 'warning'
					});
			}
			// console.log(1);
			
		},
		AddShowClick(){
                this.AddShow = false
				this.detailsObj = {}
				this.Lookteacher()
            },
		handleSelectionChange(val) {
			// console.log(val[0].id, '多选');
			this.deleteList = val
		},
		deleteClick(item) {
			let list = []
			if (item) {
				list.push(item.id)
			} else if (this.deleteList.length) {
				this.deleteList.forEach((value) => {
					list.push(value.id)
				})
			} 
			if (!list.length) {
				this.$message({
					type: 'error',
					message: '请选择要删除的数据！'
				});
				return
			}
			memberDelete({ ids: list }).then((res) => {
				this.Lookteacher()
				this.$message({
					type: 'success',
					message: '删除成功!'
				});
			}).catch((err) => {
				this.$message({
					type: 'error',
					message: err.response.data.msg || '接口异常'
				});
			});
		},
		DtlConfirmBtn(item){
			this.$confirm('请确认是否删除选中数据!', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.deleteClick(item)
				console.log(111111111111111);
				
				
			}).catch((err) => {
				
			});
		},
		// 查看学校id 
		Lookteacher() {
			let params = {
				userId: JSON.parse(localStorage.getItem('user')).id,
			}
			findTeacherInfo(params).then((res) => {
				console.log(res,'查看学校id');
				
				this.schoolInfo = res.data.data

				this.getList()
				this.handleChange()
			}).catch((err) => {
				console.log(err);
			})
		},
		//列表
		getList() {
			let params = {
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize,
			}
			SuSheListMember(params,JSON.parse(localStorage.getItem('user')).id).then((res) => {
				this.tableData = res.data.data.list
				this.total = res.data.data.total
                this.loading = false
			}).catch((err) => {
				console.log(err);
			})

		},
		//楼栋下拉列表
		handleChange() {
			console.log('1ppppp');

			let params = {
				schoolId: this.schoolInfo.schoolId,
				name: this.Dform.name,
				page: this.pageInfo.page,
				pageSize: '9999',
			}
			LoDongBuildingList(params).then((res) => {
				this.LouData = res.data.data.list

			}).catch((err) => {
				console.log(err);
			})
		},



		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.pageInfo.page = val
			this.getList()
		},

	}
}
</script>

<!-- porimse -->
<style scoped lang="scss">
.fuzzy-matching-box {
	padding-top: 40px;
	// overflow: hidden;
	// overflow: auto;
	width: 100%;
	height: 95%;
	background-color: #fff;
	border-radius: 8px;

	.fuzzy-matching-top {
		// height: 120px ;
		background-color: #fff;
		border-radius: 8px;
        margin-left: 20px;
        .query-button{
            width: 55px;
            height: 30px;
        }
        .query-button1{
            width: 55px;
            height: 30px;
            background-color: red;
            color: #fff;
        }

	}

	.block-fenye {
		// float: right;
		position: absolute;
		//   bottom: 0px;
		right: 10%;
		top: 85%;
		transform: translate(-50%, 0);

	}

	.Table-Bottom {
		height: calc(100% - 30px);
		overflow: auto;
		// position: relative;
		padding: 0px 20px;
		padding-top: 20px;
		// margin-top: 15px;
		border-radius: 8px;

		/deep/ {
			.el-table .cell {
				// font-size: 15px;
				font-size: 16px;
				color: black;
				// font-weight: 700;
				text-align: center;
				height: 30px;
				line-height: 30px;
			}

			.el-table th.el-table__cell>.cell {
				font-weight: 700;
			}
		}

		.textButton {
			// background-color: pink;
			margin: 2px;
			padding: 0px;
			font-size: 15px;
			font-weight: 700;

		}

		.shanchuBtn {
			margin: 2px;
			padding: 0px;
			font-size: 15px;
			font-weight: 700;
			color: red;
		}
	}


}
</style>